/**
 * PUBLIC AUTH
 * ===========
 * 
 * Handles public routes (login, forgot password).
 * Redirects to dashboard if already logged in.
 */

import { useLayoutEffect, useRef } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { getToken, getLoginType, isTokenExpired, clearAuth } from "./Api";

const PublicRoutes = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasRedirected = useRef(false);

  useLayoutEffect(() => {
    if (hasRedirected.current) return;

    const token = getToken();
    const loginType = getLoginType();

    // If token exists but expired, clear it
    if (token && isTokenExpired(token)) {
      clearAuth();
      return;
    }

    // If valid token, redirect to appropriate dashboard
    if (token) {
      hasRedirected.current = true;

      const from = location.state?.from?.pathname;

      if (loginType === "admin") {
        navigate(from?.startsWith("/a/") ? from : "/a/adminDash", { replace: true });
      } else {
        navigate(from?.startsWith("/d/") ? from : "/d/dashboard", { replace: true });
      }
    }
  }, [navigate, location.state?.from?.pathname]);

  // Reset on logout
  useLayoutEffect(() => {
    if (!getToken()) {
      hasRedirected.current = false;
    }
  });

  // Don't render while redirecting
  if (getToken() && !isTokenExpired(getToken())) {
    return null;
  }

  return <Outlet />;
};

export default PublicRoutes;